import { Reveal } from "@/lib/motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Guessing is expensive.",
    body: "Most revenue teams run on stale spreadsheets and gut feeling. AXIOM replaces the guesswork with a living model of your pipeline that updates the moment reality does.",
  },
  {
    n: "02",
    title: "Signals over noise.",
    body: "Every email, call and product event is a signal. We surface the three that matter this week and quietly ignore the thousand that don't.",
  },
  {
    n: "03",
    title: "Forecast you can defend.",
    body: "Numbers you can bring to the board without a disclaimer. Confidence bands, deal-level reasoning, and a paper trail for every prediction.",
  },
  {
    n: "04",
    title: "Calm by design.",
    body: "Software should lower your heart rate, not raise it. One decisive surface, generous space, and nothing on screen that isn't a decision.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-baseline justify-between border-b border-white/10 pb-6 mb-16">
            <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight text-paper">
              A short <span className="font-serif-i italic font-normal text-acid">manifesto</span>
            </h2>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/40 hidden sm:block">
              Four chapters
            </span>
          </div>
        </Reveal>

        <div className="divide-y divide-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 group">
                <div className="md:col-span-2 font-mono text-acid text-sm tracking-[0.2em]">
                  {c.n}
                </div>
                <h3 className="md:col-span-5 font-display font-semibold text-2xl md:text-4xl tracking-tight text-paper group-hover:translate-x-1 transition-transform duration-500">
                  {c.title}
                </h3>
                <p className="md:col-span-5 text-paper/55 text-base md:text-lg leading-relaxed">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
